
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { useTranslation } from 'react-i18next';

interface PaymentFormFieldsProps {
  paymentAmount: string;
  setPaymentAmount: (amount: string) => void;
  paymentDate: string;
  setPaymentDate: (date: string) => void;
  notes: string;
  setNotes: (notes: string) => void;
  totalMonthlyCost?: number;
}

const PaymentFormFields: React.FC<PaymentFormFieldsProps> = ({
  paymentAmount,
  setPaymentAmount,
  paymentDate,
  setPaymentDate,
  notes,
  setNotes,
  totalMonthlyCost = 0,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="amount" className="greek-text">
          {t('clients.paymentAmount')} *
        </Label>
        <Input
          id="amount"
          type="number"
          step="0.01"
          min="0.01"
          value={paymentAmount}
          onChange={(e) => setPaymentAmount(e.target.value)}
          placeholder="0.00"
          required
        />
        {totalMonthlyCost > 0 && (
          <p className="text-sm text-muted-foreground">
            {t('clients.monthlyAmount')}: €{totalMonthlyCost.toFixed(2)}
          </p>
        )}
      </div>

      <div className="space-y-2">
        <Label htmlFor="payment-date" className="greek-text">
          {t('common.date')} *
        </Label>
        <Input
          id="payment-date"
          type="date"
          value={paymentDate}
          onChange={(e) => setPaymentDate(e.target.value)}
          required
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="notes" className="greek-text">
          {t('clients.paymentNotes')} ({t('common.optional')})
        </Label>
        <Textarea
          id="notes"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder={t('clients.paymentNotesPlaceholder')}
          rows={3}
        />
      </div>
    </>
  );
};

export default PaymentFormFields;
